import { INTEGRATION_SVGS } from "src/app/common/svgs";

/**
 * Tool name constants and enums
 */
export enum TOOLS {
    LIST_FILES = 'ls',
    READ_FILE = 'read_file',
    WRITE_FILE = 'write_file',
    EDIT_FILE = 'edit_file',
    WRITE_TODOS = 'write_todos',
    TASK = 'task',
    DEFAULT = 'default',
    GENERATE_IMAGE = 'generate_image',
    CREATE_TODOS = 'createtodos',
    UPDATE_TODOS = 'updatetodos',
    CREATE_FILE = 'createfile',
    STR_REPLACE = 'strreplace',
    SEARCH_REPLACE = 'searchreplace',
    FULL_FILE_REWRITE = 'fullfilerewrite',
    REWRITE_FILE = 'rewritefile',
    DELETE_FILE = 'deletefile',
    REMOVE_FILE = 'removefile',
    EXECUTE_COMMAND = 'execute',
    RUN_COMMAND = 'runcommand',
    WEB_SEARCH = 'web_search',
    CRAWL_WEBPAGE = 'crawlwebpage',
    CRAWL_WEB = 'crawlweb',
    SCRAPE_WEBPAGE = 'scrapewebpage',
    SCRAPE_WEB = 'scrapeweb',
    CALL_DATA_PROVIDER = 'calldataprovider',
    GET_DATA_PROVIDER_ENDPOINTS = 'getdataproviderendpoints',
    EXECUTE_DATA_PROVIDER_CALL = 'executedataprovidercall',
    DEPLOY_SITE = 'deploysite',
    DEPLOY = 'deploy',
    EXECUTE_CODE = 'executecode',
    RUN_CODE = 'runcode',
    ASK = 'ask',
    ASK_USER = 'askuser',
    SEARCH_KNOWLEDGE_BASE = 'search_knowledge_base',
    GREP = 'grep',
    GLOB = 'glob',
    DEEP_THINK = 'deep_think',
    SEARCH_TOOLS = 'search_tools',
    COMPOSIO_SEARCH_TOOLS = 'COMPOSIO_SEARCH_TOOLS',
    IMAGE_ANALYSIS = 'image_analysis',
    KNOWLEDGE_BASE = 'knowledge_base',
    PATS_LOOKUP = 'pats_lookup',
    BROAD_SEARCH = 'broad_search',
    DEEP_SEARCH = 'deep_search',
    PRESENT_FILES = 'present_files',
    VIEW_IMAGE = 'view_image',
}

/**
 * Tool names from Python backend
 */
export enum TOOL_NAMES {
    WRITE_TODOS = 'write_todos',
    READ_FILE = 'read_file',
    WRITE_FILE = 'write_file',
    EDIT_FILE = 'edit_file',
    WEB_SEARCH = 'web_search',
    SEARCH_KNOWLEDGE_BASE = 'search_knowledge_base',
    LIST_FILES = 'ls'
}

/** Composio-based OAuth connectors */
export enum TOOLKIT_PROVIDERS {
    GMAIL = 'gmail',
    OUTLOOK = 'outlook',
    GOOGLE_SHEETS = 'googlesheets',
    GOOGLE_DOCS = 'googledocs',
    GOOGLE_SLIDES = 'googleslides',
    GOOGLE_CALENDAR = 'googlecalendar',
    GOOGLE_DRIVE = 'googledrive',
    GOOGLE_MEET = 'googlemeet',
    GOOGLE_TASKS = 'googletasks',
    ONE_DRIVE = 'one_drive',
    MICROSOFT_EXCEL = 'microsoftexcel',
    DROPBOX = 'dropbox',
    SHAREPOINT = 'share_point',
}

/** Self-hosted database connectors */
export enum DATABASE_PROVIDERS {
    POSTGRES = 'postgres',
    MYSQL = 'mysql',
    SQLITE = 'sqlite',
    MONGODB = 'mongodb',
}

/** Miscellaneous connectors (e.g. browser extension) */
export enum MISC_CONNECTORS {
    MY_BROWSER = 'MY_BROWSER',
}

/** Union of all connector provider types */
export type CONNECTOR_PROVIDERS = TOOLKIT_PROVIDERS | DATABASE_PROVIDERS | MISC_CONNECTORS;

/** Display info for every connector provider */
export const CONNECTOR_PROVIDER_INFO: Record<CONNECTOR_PROVIDERS, { name: string, icon: string }> = {
    // Toolkit (Composio) providers
    [TOOLKIT_PROVIDERS.GMAIL]: { name: 'Gmail', icon: INTEGRATION_SVGS.GMAIL },
    [TOOLKIT_PROVIDERS.OUTLOOK]: { name: 'Outlook', icon: INTEGRATION_SVGS.OUTLOOK },
    [TOOLKIT_PROVIDERS.GOOGLE_SHEETS]: { name: 'Google Sheets', icon: INTEGRATION_SVGS.GOOGLE_SHEETS },
    [TOOLKIT_PROVIDERS.GOOGLE_DOCS]: { name: 'Google Docs', icon: INTEGRATION_SVGS.GOOGLE_DOCS },
    [TOOLKIT_PROVIDERS.GOOGLE_SLIDES]: { name: 'Google Slides', icon: INTEGRATION_SVGS.GOOGLE_SLIDES },
    [TOOLKIT_PROVIDERS.GOOGLE_CALENDAR]: { name: 'Google Calendar', icon: INTEGRATION_SVGS.GOOGLE_CALENDAR },
    [TOOLKIT_PROVIDERS.GOOGLE_MEET]: { name: 'Google Meet', icon: INTEGRATION_SVGS.GOOGLE_MEET },
    [TOOLKIT_PROVIDERS.GOOGLE_TASKS]: { name: 'Google Tasks', icon: INTEGRATION_SVGS.GOOGLE_TASKS },
    [TOOLKIT_PROVIDERS.GOOGLE_DRIVE]: { name: 'Google Drive', icon: INTEGRATION_SVGS.GOOGLE_DRIVE },
    [TOOLKIT_PROVIDERS.ONE_DRIVE]: { name: 'One Drive', icon: INTEGRATION_SVGS.ONEDRIVE },
    [TOOLKIT_PROVIDERS.MICROSOFT_EXCEL]: { name: 'Microsoft Excel', icon: INTEGRATION_SVGS.MICROSOFT_EXCEL },
    [TOOLKIT_PROVIDERS.DROPBOX]: { name: 'Dropbox', icon: INTEGRATION_SVGS.DROPBOX },
    [TOOLKIT_PROVIDERS.SHAREPOINT]: { name: 'SharePoint', icon: INTEGRATION_SVGS.SHARE_POINT },
    // Database providers
    [DATABASE_PROVIDERS.POSTGRES]: { name: 'PostgreSQL', icon: INTEGRATION_SVGS.POSTGRES },
    [DATABASE_PROVIDERS.MYSQL]: { name: 'MySQL', icon: INTEGRATION_SVGS.MYSQL },
    [DATABASE_PROVIDERS.SQLITE]: { name: 'SQLite', icon: INTEGRATION_SVGS.SQLITE },
    [DATABASE_PROVIDERS.MONGODB]: { name: 'MongoDB', icon: INTEGRATION_SVGS.MONGODB },
    // Misc connectors
    [MISC_CONNECTORS.MY_BROWSER]: { name: 'My Browser', icon: INTEGRATION_SVGS.MY_BROWSER },
};